import { render, staticRenderFns } from "./Stepper.vue?vue&type=template&id=5b4d06bb&scoped=true&"
import script from "./Stepper.vue?vue&type=script&lang=js&"
export * from "./Stepper.vue?vue&type=script&lang=js&"
import style0 from "./Stepper.vue?vue&type=style&index=0&id=5b4d06bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4d06bb",
  null
  
)

export default component.exports